// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"117":"capture-app","378":"admin-app"}[chunkId] || chunkId) + "." + {"117":"16a4b146","378":"37a0f7cf","498":"a5e82ff2","722":"f61ac149","976":"f2afa58a"}[chunkId] + ".chunk.js";
};